<template>
  <div
    style="
      background-color: #fff;
    "
  >
    <div id="tabOutbox" class="margin-subpages">
      <div class="flex-row-between mt-24">
        <div style="width: 220px">
          <el-menu
            id="menuSortMonth"
            class="el-menu-demo menuOptionPowerup"
            mode="horizontal"
          >
            <el-submenu index="1" style>
              <template slot="title">
                <span class="txtOptionShowing">{{ selectedOpt }}</span>
              </template>
              <el-menu-item
                v-bind:key="item.id"
                v-for="item in selectOpt"
                index="1"
                @click="sortBy(item)"
                >{{ item.name }}</el-menu-item
              >
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="line-page mt-24 mb-12"></div>
      <div class="">
        <el-table
          :data="outbox"
          style="width: 100%"
          class="more-option-hover"
          :empty-text="
            $utils('placeholderInTable', {
              loadingLoop: loadingOutboxTable,
              table: outbox.length,
              textLoading: ' ',
              textEmpty: 'There is no outbox data available for this period',
              textNotFound: ' ',
            })
          "
        >
          <el-table-column :label="$t('powerUp.Recipient')" width="130">
            <template slot-scope="scope">
              <span
                @click="showRecipient(scope.row)"
                class="fs-14 fw-700 fc-4A4A4A"
                :class="[`${scope.row.total > 1 ? 'cursor-pointer underline' : ''}`,
                  blurMode ? 'blurelement':''
                ]"
                >{{ scope.row.send_to }}</span
              >
            </template>
          </el-table-column>

          <el-table-column :label="$t('powerUp.From')" width="130">
            <template slot-scope="scope">
              <div class="txtRegular14 content-box"
              :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.from }}</div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('powerUp.For')">
            <template slot-scope="scope">
              <div
                class="txtRegular14 content-box"
                :style="$utils('fontStyle', scope.row.for) + ';'"
              >
                {{ scope.row.for }}
              </div>
            </template>
          </el-table-column>

          <el-table-column :label="$t('powerUp.Reward')" width="100">
            <template slot-scope="scope">
              <div v-if="scope.row.type == 'medal'" class="fw-700">
                <div class="txtRegular14 ellipsis" style="max-width: 80px">
                  🏅{{ scope.row.reward }}
                </div>
              </div>
              <div v-else class="fw-700">
                <span class="txtRegular14"
                  >+{{
                    $utils("addCommasInNumber", scope.row.amount)
                  }}&nbsp;</span
                >
                <span class="txtRegular14">{{ scope.row.unit }}</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('powerUp.Sent_on')"
            width="190"
            header-align="right"
            align="right"
          >
            <template slot-scope="scope">
              <span v-if="checkDate(scope.row)" class="txtRegular14"
                >({{ scope.row.send_on }})</span
              >
              <span v-else class="txtRegular14">{{ scope.row.send_on }}</span>
            </template>
          </el-table-column>

          <el-table-column width="25" header-align="right" align="right">
            <template slot-scope="scope">
              <span class="more-options">
                <el-tooltip effect="none" placement="bottom-end">
                  <div slot="content" class="relative">
                    <div class="hamburger-menu">
                      <div class="top" @click="duplicateButtonClick(scope.row)">
                        {{ $t("powerUp.Duplicate") }}
                      </div>
                      <div
                        class="bottom"
                        v-if="checkDate(scope.row)"
                        @click="deleteButtonClick(scope.row)"
                      >
                        {{ $t("powerUp.Delete") }}
                      </div>
                    </div>
                  </div>
                  <el-button
                    icon="el-icon-more"
                    size="mini"
                    class="hide-button"
                    circle
                  ></el-button>
                </el-tooltip>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="center mt-10 mb-40 pt-10 pb-40"
          v-if="!loadingOutboxTable && outbox.length === 0"
        >
          <loading-even></loading-even>
        </div>
      </div>
      <div class="flex-center pagination mt-14">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-size="10"
          :pager-count="5"
          layout="prev, pager, next"
          :total="results"
        ></el-pagination>
        <span class="results-status">
          {{ outbox.length }} {{ $t("powerUp.results_from") }}
          {{ $utils("addCommasInNumber", results) }} {{ $t("powerUp.results") }}
        </span>
      </div>
    </div>
    <el-dialog :visible.sync="showMultipleRecipients" top="8vh">
      <div class="recipients-modal">
        <div>
          <span class="fs-20 fw-700 fc-000000"
            >{{ $t("powerUp.outbox_multiple") }} ({{
              $utils("addCommasInNumber", multipleRecipientsFocus.total)
            }}) {{ $t("powerUp.Recipients") }}</span
          >
        </div>
        <div
          class="mt-24 width-for fs-18 fw-700 fc-000000 ellipsis"
          :style="$utils('fontStyle', multipleRecipientsFocus.for) + ';'"
        >
          {{ multipleRecipientsFocus.for }}
        </div>
        <div class="mt-4">
          <span class="fc-626262 fs-14">{{
            multipleRecipientsFocus.sendDate
          }}</span>
        </div>
      </div>
      <div
        v-if="loadingRecipients"
        class="flex-mid my-40 pt-30"
      >
        <loading-even></loading-even>
      </div>
      <div v-else class="multiple-recipients thin-scrollbar">
        <div
          v-for="item in multipleRecipients"
          :key="item.email"
          class="rowDataStyle"
        >
          <div class="columnDataStyle" style="width: 100%">
            <div class="flex-center py-7">
              <div v-if="item.image">
                <img
                  v-lazy="item.image"
                  :key="item.image"
                  class="image-skeleton image-profile-42 flex-mid mr-16"
                  :class="[ blurMode ?  'blurelement': '' ]"
                />
              </div>
              <div v-else class="image image-profile-42 flex-mid mr-12"
              :class="[ blurMode ?  'blurelement': '' ]">
                <div
                  class="flex-mid text-in-image text-in-image-42"
                  style="width: 42px"
                >
                  {{
                    $utils("acronymName", {
                      firstName: item.firstname || item.name,
                      lastName: item.lastname || "l",
                    })
                  }}
                </div>
              </div>
              <div class="flex-column pl-4">
                <span class="text-name"
                :class="[ blurMode ?  'blurelement': '' ]" style="width: 200px"
                  >{{ item.firstname || item.name }}
                  {{ item.lastname || "Lastname" }}</span
                >
                <span class="text-email"
                :class="[ blurMode ?  'blurelement': '' ]" style="width: 200px">{{
                  item.email
                }}</span>
              </div>
              <div class="fc-4A4A4A fs-14"
              :class="[ blurMode ?  'blurelement': '' ]">
                {{ item.teamName || "-" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "outbox",
  components: {
    loadingEven: require("../even/loading").default,
  },
  data() {
    return {
      current_page: 1,
      loadingOutboxTable: -1,
      selectedOpt: "All-time",
      showMultipleRecipients: false,
      multipleRecipientsFocus: {
        for: "",
        total: "",
        sendDate: "Sent on Feb 28, 2020 at 1:20PM",
      },
      // multipleRecipients: [
      //   {
      //     image: false,
      //     email: "Bibi@email.com",
      //     firstname: "Bibi",
      //     lastname: "Sheppard",
      //     teamName: "HR",
      //   }

      // ],
    };
  },
  created() {
    this.$store.dispatch("outbox/getList_month", this.user);
    this.$store.dispatch("outbox/getTeamOrganization1level", this.user).then(()=>{
      this.$store.dispatch("outbox/getDataAll", {
        user: this.user,
        start: this.selectedOpt,
        end: this.selectedOpt,
      });
    });
  
    
    this.$store.commit("authen/setActiveIndex", "2");
    
  },
  computed: {
    user() {
      return this.$store.getters["authen/user"];
    },
    outbox() {
      this.loadingOutboxTable = ++this.loadingOutboxTable;
      return this.$store.getters["outbox/outbox"];
    },
    outboxall() {
      return this.$store.getters["outbox/outboxall"];
    },
    page() {
      return this.$store.getters["outbox/page"];
    },
    results() {
      return this.$store.getters["outbox/results"];
    },
    selectOpt() {
      return this.$store.getters["outbox/list_month"];
    },
    loadingRecipients() {
      return this.$store.getters["outbox/loadingRecipients"];
    },
    multipleRecipients() {
      return this.$store.getters["outbox/multipleRecipients"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.current_page = val;
      this.$store.dispatch("outbox/currentChange", val);
    },
    duplicateButtonClick(item) {
      this.$confirm(
        `Are you sure you would like to {{ $t("powerUp.Duplicate") }} this recognition event?`,
        "Warning",
        {
          dangerouslyUseHTMLString: true,
          confirmButtonText: "Yes",
          cancelButtonText: "Cancel",
          type: "warning",
        }
      )
        .then(() => {

          this.$store.commit("powerups/setActiveTabs", {
            activeName: "create",
            renderComponent: true,
          });
          this.$store.commit("powerups/setObjDuplicate", item);
          this.$message({
            type: "success",
            message: "Recognition event duplicated",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Canceled",
          });
        });
    },
    deleteButtonClick(value) {
      const text = `This will delete this Power-ups(${value.reward}). Continue?`;
      this.$confirm(text, "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.$store.dispatch("outbox/deletePowerup", value);
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Delete completed",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    checkDate(value) {
      if (value) {
        let time = value.when.split("-");
        const year = time[0];
        const month = Number(time[1]) - 1;
        let time2 = time[2].split(" ");
        const day = time2[0];
        let time3 = time2[1].split(":");
        const hour = time3[0];
        const minute = time3[1];
        const d = new Date();
        const c = new Date(year, month, day, hour, minute);
        if (d.getTime() < c.getTime()) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    sortBy(id) {
      this.selectedOpt = id.name;
      this.loadingOutboxTable = -1;
      if (id.name != "All-time") {
        this.$store.dispatch("outbox/getData", {
          user: this.user,
          start: id.name,
          end: id.name,
        });
      } else {
        this.$store.dispatch("outbox/getDataAll", {
          user: this.user,
          start: "",
          end: "",
        });
      }
    },
    showRecipient(value) {
      
      this.multipleRecipientsFocus.for = value.for;
      this.multipleRecipientsFocus.sendDate = value.send_on;
      this.showMultipleRecipients = true;
      this.$store.dispatch("outbox/getUser", value).then((res) => {
        this.multipleRecipientsFocus.total = res;
      });
      this.multipleRecipients = value.to;
    },
  },
};
</script>

<style scoped lang="scss">
// #taboutbox >>> .divContentOutbox {
//   flex: 1;
//   display: flex;
//   flex-direction: column;
//   background: #fff;
// }
.txtRegular14 {
  font-size: 14px;
  color: #4a4a4a;
  word-break: normal;
}
.content-box {
  display: block;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
.btnActionDuplicate {
  color: #747474;
  font-size: 15px;
  font-weight: 700;
}
.el-table th > .cell {
  font-weight: 500;
}
.hide-button {
  transform: rotate(90deg);
  border-width: 0px;
  &:hover {
    color: #606266;
    border-color: transparent;
    background-color: transparent;
  }
}
.line-page {
  background-color: #e0e0e0;
  height: 1px;
}
.menuOptionPowerup {
  width: 240px;
  border-color: #c7c7c7;
  border-radius: 4px;
  height: 40px;
}
.txtOptionShowing {
  color: #000000;
  font-size: 14px;
  margin-left: 16px;
}

.multiple-recipients {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 0 0;
  margin: 0 0 0 16px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 55vh;
}
.recipients-modal {
  padding-left: 40px;
  padding-bottom: 16px;
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 6px 6px #00000014;
  opacity: 1;
}
.width-for {
  width: calc(99% - 20px);
}
</style>   

<style lang="scss">
#tabOutbox .el-submenu__title {
  height: 40px;
  line-height: 40px;
  background-color: #f4f4f4;
}
#tabOutbox .el-menu--horizontal > .el-menu-item {
  color: rgba(0, 0, 0, 0.62);
  font-size: 14px;
  font-weight: 400;
  height: 40px;
}
#tabOutbox .el-menu--horizontal .el-menu-item:not(.is-disabled):hover,
.el-menu--horizontal .el-menu-item:not(.is-disabled):focus .el-menu-item:hover {
  background-color: transparent;
  color: #6c30cc;
}
#tabOutbox .el-menu--horizontal > .el-menu-item.is-active {
  background-color: transparent;
  border-bottom: 2px solid #6c30cc;
  color: #6c30cc;
  font-weight: 700;
}
#menuSortMonth > li > div {
  border-radius: 4px;
  width: 240px;
  height: 36px;
  line-height: 40px;
}
#menuSortMonth > li {
  margin-top: 0px;
  width: 240px;
  height: 36px;
}
#menuSortMonth > li > div > i {
  margin-right: 9%;
  float: right;
  margin-top: 6%;
}
</style>